// eslint-disable-next-line no-unused-vars
import globals from '../../configs/globals';

const AccessControl = Object.freeze({
    rights: Object.freeze(JSON.parse(atob(globals.acl))),

    /**
     *
     * @param {String} resource
     *
     * FOR TEST USE ONLY
     */
    permit: function(resource) {
        this.rights[resource] = true;
        app.accessRightsUpdated++;
    },

    /**
     *
     * @param {String} resource
     *
     * FOR TEST USE ONLY
     */
    revoke: function(resource) {
        this.rights[resource] = false;
        app.accessRightsUpdated++;
    },

    has: function(...resources) {
        for(let i in resources) {
            if (!this.rights.hasOwnProperty(resources[i]) || this.rights[resources[i]] !== true) return false
        }
        return true;
    },
});

const PM_access_control = {};
PM_access_control.install = function (Vue, options) {
    Object.defineProperty(Vue.prototype, '$acl', {
        value: AccessControl,
        enumerable: false,
        configurable: false,
        writable: false
    });
};

export default PM_access_control;
